import React from 'react';
import I18n from 'i18n-js';

import { RCAlertBox } from '@reverbdotcom/cadence/components';
import { SearchQueryInfo } from '@reverbdotcom/commons/src/gql/graphql';

export function LowResultsBanner({ queryInfo }: { queryInfo: SearchQueryInfo | null }) {
  if (!queryInfo?.displayInfo[0]?.displayMessage) {
    return null;
  }

  return (
    <div className="mb-6">
      <RCAlertBox
        type="info"
        headerText={I18n.t('discovery.noResults.searchReturningLowResults')}
      >
        <div className="d-flex fx-align-center fx-wrap">
          {queryInfo.displayInfo[0].displayMessage}
        </div>
      </RCAlertBox>
    </div>
  );
}

export default LowResultsBanner;
